import Common from '../../../Common';

interface Body {
	member_of: string
	user_settings_template_template_id: id
}

export interface CompanyAdSyncUserSettingsTemplate {
	id: id
	adsync_id: id
	user_settings_template_template_id: id
	member_of: string
}

const UserSettingsTemplate = class extends Common {
	browse = (companyId: id, adSyncId: id): CustomResponse<CompanyAdSyncUserSettingsTemplate[]> =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/usersettingstemplate`)

	create = (companyId: id, adSyncId: id, body: Body) =>
		this.post(`/company/${companyId}/adsync/${adSyncId}/usersettingstemplate`, body)

	delete = (companyId: id, adSyncId: id, id: id) =>
		this.doDelete(`/company/${companyId}/adsync/${adSyncId}/usersettingstemplate/${id}`)

	available = (companyId: id, adSyncId: id): CustomResponse<string[]> =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/usersettingstemplate/available`)
}

export default UserSettingsTemplate
